import PropTypes from 'prop-types'
import { MarkerItem } from '@calendly/booking-kit'
import { TitleText } from '@calendly/ui/components/typography'


const Marker = ({ text }) => (
  <MarkerItem>
    <TitleText size="large" level={2}>{text}</TitleText>
  </MarkerItem>
)

Marker.propTypes = {
  text: PropTypes.string.isRequired
}

export default Marker
